module.exports = __webpack_public_path__ + "static/media/banquet-table-pretzels-triangle-plates.ea1242a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/banquet-table-pretzels-triangle-plates.jpg
// module id = 824
// module chunks = 0